module.exports = __webpack_public_path__ + "static/logo-2e137e5f9eae4601462663489a984241.png";